import React from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from 'react-router-dom';

function CardShortcutItem(props) {
    const { card } = props;
  return (
    <>
        <Col xs={3} className="mb-4">
            <div className={`mt-3 h-100 ${card.classStyle}`}>
                <Row>
                    <Link as={Link}to={"/"+card.path}>
                        <Col xs="12">
                            <span>
                                <img src={card.iconUrl} className="ic-sc-menu" alt="" />
                            </span>
                        </Col>
                        <Col xs="12" className="mt-2">
                            <label className="mb-0 fontLight font-size05 colorWhite">
                                {card.title}
                            </label>
                        </Col>
                        <Col xs="12" className="mgt01">
                            <font className="fontLight font-size05 colorWhite">
                                {card.text}
                            </font>
                        </Col>
                    </Link>
                </Row>
            </div>
        </Col>
    </>
  )
}

export default CardShortcutItem;